import { render, staticRenderFns } from "./ShopSummary.vue?vue&type=template&id=0874d145&scoped=true"
import script from "./ShopSummary.vue?vue&type=script&lang=js"
export * from "./ShopSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0874d145",
  null
  
)

export default component.exports